module.exports = __webpack_public_path__ + "img/elo.9e6fd9a0.svg";